module.exports = __webpack_public_path__ + "static/img/SEC.fbb86e59.png";